query BillingSeller {
  billingSeller {
    id
    companyName
    registrationNumber
    vatNumber
    address
    email
    invoiceNumberPrefix
    invoiceLanguage
    vatNote
    signerName
    signerPosition
    logo {
      id
    }
    brandColor
    bankAccounts {
      currency
      beneficiary
      bankName
      bankAddress
      iban
      swift
      instructions
    }
    filled
  }
}
